import { FC, JSX } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import Switch from '@semcore/ui/switch';

import { Content } from '@/entities/content/api/types';
import { type SelectOption, Select } from '@/shared';

import { firstUpdateOptions, periodOptions } from '../../../lib/constants';
import { selectOption } from '../../../lib/utils';

import s from './MetadataSettings.module.css';

export interface IAutoUpdateSettingsProps {}

export const AutoUpdateSettings: FC<
  IAutoUpdateSettingsProps
> = (): JSX.Element => {
  const { control, watch } = useFormContext<Content>();
  const autoUpdate = watch('rss_settings.auto_update.enabled');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-3">
        <div className="flex grow text-sm font-semibold text-black dark:text-white">
          Auto update
        </div>

        <Controller
          control={control}
          name="rss_settings.auto_update.enabled"
          render={({ field: { value = false, onChange } }) => (
            <Switch size="l">
              <Switch.Value
                checked={value}
                onChange={(checked) => onChange(checked)}
              />
            </Switch>
          )}
        />
      </div>
      {autoUpdate && (
        <div className="flex flex-col gap-6">
          <div className={`flex flex-col gap-1 ${s.ffield}`}>
            <Controller
              control={control}
              name="rss_settings.auto_update.time"
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <>
                  <Select
                    current={selectOption(firstUpdateOptions, value)}
                    options={firstUpdateOptions}
                    onChange={(sel: SelectOption) => onChange(sel.value)}
                    placeholder="First update"
                  />
                  {error && (
                    <div className="text-sm font-light text-red">
                      {error?.message}
                    </div>
                  )}
                </>
              )}
            />
          </div>
          <div className={`flex flex-col gap-1 ${s.ffield}`}>
            <Controller
              control={control}
              name="rss_settings.auto_update.interval_days"
              render={({
                field: { value = undefined, onChange },
                fieldState: { error },
              }) => (
                <>
                  <Select
                    current={selectOption(periodOptions, value)}
                    options={periodOptions}
                    onChange={(sel: SelectOption) => onChange(sel.value)}
                    placeholder="Period"
                  />
                  {error && (
                    <div className="text-sm font-light text-red">
                      {error?.message}
                    </div>
                  )}
                </>
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AutoUpdateSettings;
